import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { FeatureLayout } from '@lendica/components';
import { useDataConnectionDataContext } from './DataConnectionData';
import { Accounting } from './components/Accounting';
import { PointOfSale } from './components/PointOfSale';
import { useActiveCompanyId, useContainerWidth } from '@lendica/hooks';

export const DataConnectionContainer: FC<{ env: string; children: any }> = ({ children, env }) => {
    const { isNarrow } = useContainerWidth();
    const { isLoading, connections } = useDataConnectionDataContext();
    // const company_id = company ? company.id : '';
    const companyId = useActiveCompanyId();

    return (
        <FeatureLayout loading={isLoading}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    height: '100%',
                    px: isNarrow ? 2 : 4,
                    boxSizing: 'border-box',
                }}
            >
                <Box
                    sx={{
                        mt: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="subtitle1" my={3} fontWeight={500}>
                        Integrations
                    </Typography>
                </Box>
                {!isLoading && (
                    <Accounting env={env} company_id={companyId} connections={connections} />
                )}
                {!isLoading && (
                    <PointOfSale company_id={companyId} env={env} connections={connections} />
                )}
            </Box>
        </FeatureLayout>
    );
};
